import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';

import { selectTenantHasFeatureFlag } from '@core/stores/auth/auth.selectors';

import { FeatureFlags } from '@domain/tenant/tenant.enums';

import { SITE_TIME_ZONE } from '@shared/context/site-time-zone.context';
import { SiteDateTimeFormat, SiteDateTimeValue, formatSiteDateTime } from '@shared/helpers/date/format-site-date-time.helper';
import { PopoverDirective } from '@shared/modules/popover';
import { DEFAULT_TIMEZONE } from '@shared/utils/locales';

import { LoadingSkeletonComponent } from '../loading-skeleton';

@Component({
  selector: 'app-site-date-time',
  imports: [LoadingSkeletonComponent, PopoverDirective, TranslatePipe],
  templateUrl: './site-date-time.component.html',
  host: {
    class: 'inline-flex flex-col',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteDateTimeComponent {
  readonly #store = inject(Store);
  readonly #siteTimeZone = inject(SITE_TIME_ZONE);

  public readonly value = input.required<SiteDateTimeValue>();
  public readonly isLoading = input(false);
  public readonly timeZone = input<string>();
  public readonly format = input<SiteDateTimeFormat>('dateTime');
  public readonly presentation = computed(() =>
    formatSiteDateTime(this.value(), this.timeZone() || this.#siteTimeZone() || DEFAULT_TIMEZONE, this.format())
  );
  public readonly displayTimezones = this.#store.selectSignal(selectTenantHasFeatureFlag(FeatureFlags.DisplayTimezones));
}
